import { render, staticRenderFns } from "./DocumentAgentDetail.vue?vue&type=template&id=5835ef5a&scoped=true&lang=pug"
import script from "./DocumentAgentDetail.vue?vue&type=script&lang=js"
export * from "./DocumentAgentDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentAgentDetail.vue?vue&type=style&index=0&id=5835ef5a&prod&scoped=true&lang=css"
import style1 from "./DocumentAgentDetail.vue?vue&type=style&index=1&id=5835ef5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835ef5a",
  null
  
)

export default component.exports